// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2VFkV","textArea":"styles_textArea__16KoB","textAreaError":"styles_textAreaError__1VA9M"};